var exports = {
  "Lw": "AvatarDecorationOverlay.module__overlay___cVpseD",
  "rV": "AvatarDecorationOverlay.module__svgRoot___cVpseD",
  "H7": "AvatarDecorationOverlay.module__flamePulse___cVpseD",
  "Nx": "AvatarDecorationOverlay.module__haloFloat___cVpseD",
  "JJ": "AvatarDecorationOverlay.module__starTwinkle___cVpseD",
  "xB": "AvatarDecorationOverlay.module__cyberPulse___cVpseD",
  "dh": "AvatarDecorationOverlay.module__petalSway___cVpseD",
  "Bw": "AvatarDecorationOverlay.module__spectralSway___cVpseD",
  "vG": "AvatarDecorationOverlay.module__portalSpin___cVpseD",
  "zO": "AvatarDecorationOverlay.module__portalSpinReverse___cVpseD",
  "BN": "AvatarDecorationOverlay.module__animatedFlame___cVpseD",
  "CJ": "AvatarDecorationOverlay.module__animatedHalo___cVpseD",
  "ch": "AvatarDecorationOverlay.module__animatedStar___cVpseD",
  "td": "AvatarDecorationOverlay.module__animatedStarAlt___cVpseD",
  "NG": "AvatarDecorationOverlay.module__animatedCyber___cVpseD",
  "Sw": "AvatarDecorationOverlay.module__animatedPetal___cVpseD",
  "sR": "AvatarDecorationOverlay.module__animatedSpectral___cVpseD",
  "Z8": "AvatarDecorationOverlay.module__animatedPortalOuter___cVpseD",
  "jm": "AvatarDecorationOverlay.module__animatedPortalInner___cVpseD",
  "LE": "AvatarDecorationOverlay.module__demonEmber___cVpseD",
  "yY": "AvatarDecorationOverlay.module__galaxyWobble___cVpseD",
  "Uk": "AvatarDecorationOverlay.module__lightningPulse___cVpseD",
  "uL": "AvatarDecorationOverlay.module__batFlutter___cVpseD",
  "pE": "AvatarDecorationOverlay.module__diamondGleam___cVpseD",
  "$y": "AvatarDecorationOverlay.module__heartBeat___cVpseD",
  "om": "AvatarDecorationOverlay.module__rgbCycle___cVpseD",
  "DN": "AvatarDecorationOverlay.module__dragonAura___cVpseD",
  "zj": "AvatarDecorationOverlay.module__oceanSurge___cVpseD",
  "BQ": "AvatarDecorationOverlay.module__toxicGlow___cVpseD",
  "s2": "AvatarDecorationOverlay.module__animatedDemonEmber___cVpseD",
  "IV": "AvatarDecorationOverlay.module__animatedGalaxy___cVpseD",
  "eL": "AvatarDecorationOverlay.module__animatedLightning___cVpseD",
  "Rt": "AvatarDecorationOverlay.module__animatedBat___cVpseD",
  "y": "AvatarDecorationOverlay.module__animatedDiamond___cVpseD",
  "od": "AvatarDecorationOverlay.module__animatedHeart___cVpseD",
  "X6": "AvatarDecorationOverlay.module__animatedRgb___cVpseD",
  "nC": "AvatarDecorationOverlay.module__animatedDragon___cVpseD",
  "VO": "AvatarDecorationOverlay.module__animatedWave___cVpseD",
  "bi": "AvatarDecorationOverlay.module__animatedToxic___cVpseD",
};

module.exports = exports;
